/** Max size for a single video attachment on the dashboard (bytes). */
export const MAX_VIDEO_UPLOAD_BYTES = 200 * 1024 * 1024;

export const MAX_VIDEO_UPLOAD_MB = 200;

/** HTML `accept` for notice video inputs — no `video/*` or WebM (iOS / app playback). */
export const NOTICE_VIDEO_INPUT_ACCEPT =
  ".mp4,.mov,.mpeg,.avi,.wmv,.3gp,video/mp4,video/mpeg,video/quicktime,video/x-msvideo,video/x-ms-wmv,video/3gpp";

const ALLOWED_VIDEO_MIME_TYPES = new Set([
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "video/x-msvideo",
  "video/x-ms-wmv",
  "video/3gpp",
]);

const ALLOWED_VIDEO_EXTENSION = /\.(mp4|mov|mpeg|avi|wmv|3gp)$/i;

/** Whether this file may be uploaded as a notice video attachment. */
export function isAllowedNoticeVideoUpload(file: File): boolean {
  const name = file.name.toLowerCase();
  if (name.endsWith(".webm") || file.type === "video/webm") {
    return false;
  }
  if (ALLOWED_VIDEO_MIME_TYPES.has(file.type)) {
    return true;
  }
  return ALLOWED_VIDEO_EXTENSION.test(name);
}

export function isVideoUploadFile(file: File): boolean {
  return isAllowedNoticeVideoUpload(file);
}

export function getVideoUploadSizeError(file: File): string | null {
  if (!isVideoUploadFile(file)) {
    return null;
  }
  if (file.size <= MAX_VIDEO_UPLOAD_BYTES) {
    return null;
  }
  const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
  return `Video "${file.name}" is too large (${fileSizeMB}MB). Max ${MAX_VIDEO_UPLOAD_MB}MB.`;
}
